<template>
  <!-- 时间 -->
  <div class='timeTemp'>
    <div class="x-d-flex">
      <!-- 截止日期 -->
      <div class="x-d-flex x-m-r-10 x-m-t-10">
        <div class="x-m-r-10 x-lh-32">时间</div>
        <!-- <el-date-picker
          v-model="closingDate"
          class="x-lh-24 x-p-0"
          :clearable='false'
          @change="setUser(closingDate)"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker> -->
        <el-date-picker style="width: 183px;" class='' v-model="startTime" type="datetime" :clearable='false'
          value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始日期" @change="fChgTime('Custom')">
        </el-date-picker>
        <div class="x-m-r-10 x-m-l-10 x-lh-32">至</div>
        <el-date-picker style="width: 183px;" class='' v-model="overTime" type="datetime" :clearable='false'
          value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束日期" @change="fChgTime('Custom')">
        </el-date-picker>
      </div>
      <!-- 时间 -->
      <div class="x-d-flex x-m-t-10">
        <div class="x-d-flex x-row-left">
          <el-button-group class="x-h32">
            <el-button v-for="(item,index) in listDate" :key="index" class="x-h32 x-p-0 x-w60"
              :class="listDateIndex == index ?'active':''" @click="today(index)">{{item.name}}</el-button>
          </el-button-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    components: {},
    props: {
      numchuan: {
        type: Number,
        default: ""
      }
    },
    data() {
      return {
        closingDate: [],
        startTime: '',
        overTime: '',
        listDateIndex: 0,
        listDate: [{
          id: 1,
          name: "今天"
        }, {
          id: 2,
          name: "昨天",
        }, {
          id: 3,
          name: "本月",
        }, {
          id: 4,
          name: "近7天",
        }, {
          id: 5,
          name: "近30天",
        }],
        gysTP: 0,
        gysTotal: 0,
      };
    },
    computed: {},
    watch: {
      numchuan(item) {
        this.listDateIndex = item
        this.$store.commit('setListDateIndex', this.listDateIndex)
      },
      closingDate(newVal) {
        this.startTime = newVal[0]
        this.overTime = newVal[1]
      }
    },
    methods: {
      //时间框改变
      fChgTime(type) {
        if (type == 'Custom') {
          this.listDateIndex = -1
        }
        this.closingDate = [this.startTime, this.overTime]
        this.$store.commit('setTimeData', this.closingDate)
        this.$store.commit('setListDateIndex', this.listDateIndex)
        this.$emit('today', [this.closingDate, this.gysTP, this.gysTotal])
      },
      //点击获取时间【固定】
      today(index) {
        //阻止重复点击
        if(this.listDateIndex == index){
          return
        }
        this.listDateIndex = index
        this.closingDate = [] //清空当前的时间
        if (index == 0) {
          this.closingDate = [this.api.timeHelper.fGetQhDay(0) + ' 00:00:00', this.api.timeHelper.fGetNowTime(1) +
            ' 23:59:59'
          ];
        } else if (index == 1) {
          this.closingDate = [this.api.timeHelper.fGetQhDay(-1) + ' 00:00:00', this.api.timeHelper.fGetQhDay(-1) +
            ' 23:59:59'
          ];
        } else if (index == 2) {
          this.closingDate = [this.api.timeHelper.getMonthStartDate() + ' 00:00:00', this.api.timeHelper
            .getMonthEndDate() + ' 23:59:59'
          ];
        } else if (index == 3) {
          this.closingDate = [this.api.timeHelper.fGetQhDay(-6) + ' 00:00:00', this.api.timeHelper.fGetNowTime(1) +
            ' 23:59:59'
          ];
        } else if (index == 4) {
          this.closingDate = [this.api.timeHelper.fGetQhDay(-29) + ' 00:00:00', this.api.timeHelper.fGetNowTime(1) +
            ' 23:59:59'
          ];
        }
        this.$store.commit('setTimeData', this.closingDate)
        this.$store.commit('setListDateIndex', this.listDateIndex)
        this.$emit('today', [this.closingDate, this.gysTP, this.gysTotal])
      },
      // 点击获取时间【非固定】
      setUser(item) {
        this.$emit('transfer', item)
      },
    },
    beforeCreate() {},
    async created() {
      // 时间
      // let timeData = this.$store.state.timeData;
      // if (timeData.length > 0) {
      //   this.closingDate = timeData
      //   this.startTime = timeData[0]
      //   this.overTime = timeData[1]
      // } else {
        // 默认获取今天的时间
        this.closingDate = [this.api.timeHelper.fGetQhDay(0) + ' 00:00:00', this.api.timeHelper.fGetNowTime(1) +
            ' 23:59:59'
          ];
        this.startTime = this.api.timeHelper.fGetQhDay(0) + ' 00:00:00'
        this.overTime = this.api.timeHelper.fGetNowTime(1) + ' 23:59:59'
      // }
      // 下标
      // let list = this.$store.state.listDateIndex;
      this.listDateIndex = 0
    },
    beforeMount() {},
    async mounted() {}
  }
</script>
<style lang="less" scoped="scoped">
  .timeTemp {

    //按钮样式==颜色
    /deep/ .active {
      color: #409EFF;
      border-color: #409EFF;
      background-color: #fff;
      z-index: 10;
    }

    /deep/.el-input--suffix .el-input__inner {
      padding-right: 0;
    }

    /deep/.el-input__icon {
      line-height: 32px !important;
    }

    .el-button:focus,
    .el-button:hover {
      color: #409EFF;
      border-color: #409EFF;
      background-color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Time.vue